import { TileLayer } from '@deck.gl/geo-layers';

import { geoBbox } from './tileBbox';
import { renderBitmapTileSubLayer } from './renderBitmapTileSubLayer';

export const militaryHistoricalLayers = {
  firstMilitary: 'https://www.chartae-antiquae.cz/TMS/Military1/{z}/{x}/{y}',
  secondMilitary: 'https://www.chartae-antiquae.cz/TMS/Military2/{z}/{x}/{y}',
};

export const historicalMilitaryLayer = (
  layer = militaryHistoricalLayers.secondMilitary
) =>
  new TileLayer({
    id: `historical-military-layer`,
    data: [layer],
    /*
    THIS DOES NOT SUPPORT WGS-84 only Krovak
    getTileData: async ({ index: { x, y, z }, bbox: { east, south, north, west } }) => {
      const url = `https://gis.cenia.cz/mapcache/II_vojenske_mapovani/wms?layers=II_vojenske_mapovani&EXCEPTIONS=application%2Fvnd.ogc.se_inimage&VERSION=1.1.1&format=image/png&bbox=${west},${south},${east},${north}&srs=EPSG%3A4326&request=GetMap&width=256&height=256&service=WMS&transparent=true&STYLES=`;
      const result = await fetch(url);
      const data = await parse(result);
      return data;
    },
    */
    maxRequests: 17,
    pickable: true,
    highlightColor: [60, 60, 60, 40],
    minZoom: 0,
    maxZoom: 20,
    tileSize: 256,
    opacity: 0.7,
    renderSubLayers: renderBitmapTileSubLayer,
  });
